import { defineStore } from "pinia";
import _ from 'lodash';

import type { IDelivererTypeVm } from "@/types";

export const useDelivererTypesStore = defineStore({
    id: "useDelivererTypesStore",
    state: () => ({
        delivererTypes: [] as Array<IDelivererTypeVm>,
        isLoadingDeliverTypes: false
    }),
    getters: {},
    actions: {
        async loadDelivererTypes() {
            if(this.delivererTypes && this.delivererTypes.length > 0) return

            if(this.isLoadingDeliverTypes) {
                return;    
            }

            this.isLoadingDeliverTypes = true;
            try {
                var url = `/api/Participation/GetDelivererTypes`;
                const response = await this.axiosFactory.withoutToken().get(url);
                this.delivererTypes = response.data.data;
            } catch (error: any) {
                console.log(error.response)
            } finally {
                this.isLoadingDeliverTypes = false;
            }
        },
    }
});
